import { c as _c } from "react/compiler-runtime";
import { formatDistanceStrict } from 'date-fns';
import { Issue } from '../../../../../../../../typings/Issue.interface';
import { getIssueTitleParts, issue_actions, ISSUE_STATUS_CONFIGS, issue_type_configs } from '../../../../../utils/issues';
import Button, { ButtonGroup } from '../../../../common/base/Button';
import Icon from '../../../../common/base/Icon';
import Link from '../../../../common/base/Link';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import { Div } from '../../../../common/helpers/StyledUtils';
import PreviewHistogram from '../../../../common/Histogram/PreviewHistogram';
import ClickableRow from '../../../../common/Table/ClickableRow';
import IssueTitle from '../IssueTitle';
import { IssuesRenderData } from './';
const DotDivider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Text size="xs">·</Text>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const IssueSection: React.FC<{
  issue: Issue;
  render_data: IssuesRenderData;
  applyAction: (ids: string[], action: keyof typeof issue_actions) => void;
}> = t0 => {
  const $ = _c(99);
  const {
    issue,
    render_data,
    applyAction
  } = t0;
  let t1;
  if ($[0] !== issue || $[1] !== render_data) {
    t1 = getIssueTitleParts(issue, render_data);
    $[0] = issue;
    $[1] = render_data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const title_parts = t1;
  const {
    default_action,
    current_action
  } = ISSUE_STATUS_CONFIGS[issue.status];
  const t2 = `/issues/${issue.id}`;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      justify: "space-between",
      align: "center"
    };
    t4 = {
      x: 6,
      y: 4
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      direction: "column",
      grow: true,
      gap: 1
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title_parts) {
    t6 = <IssueTitle parts={title_parts} size="m" />;
    $[6] = title_parts;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      justify: "space-between",
      align: "center",
      gap: 2
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      gap: 2
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      align: "center",
      gap: 1
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = issue.status === "OPENED";
  const t11 = issue.status === "ACKNOWLEDGED";
  const t12 = issue.status === "RESOLVED";
  const t13 = ISSUE_STATUS_CONFIGS[issue.status];
  const t14 = issue.status === "IGNORED";
  let t15;
  if ($[11] !== t10 || $[12] !== t11 || $[13] !== t12 || $[14] !== t13.icon || $[15] !== t14) {
    t15 = <Icon danger={t10} warning={t11} success={t12} icon={t13.icon} muted={t14} />;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13.icon;
    $[15] = t14;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const t16 = ISSUE_STATUS_CONFIGS[issue.status];
  let t17;
  if ($[17] !== t16.label) {
    t17 = <Text semi={true} muted={true} size="xs">{t16.label}</Text>;
    $[17] = t16.label;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t15 || $[20] !== t17) {
    t18 = <Div flex={t9}>{t15}{t17}</Div>;
    $[19] = t15;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <DotDivider />;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  const t20 = `Last seen on ${issue.first_seen_at}`;
  let t21;
  if ($[23] !== issue.last_seen_at) {
    t21 = formatDistanceStrict(new Date(issue.last_seen_at), new Date(), {
      addSuffix: true
    });
    $[23] = issue.last_seen_at;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  let t22;
  if ($[25] !== t21) {
    t22 = <Text semi={true} muted={true} size="xs">{t21}</Text>;
    $[25] = t21;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  let t23;
  if ($[27] !== t20 || $[28] !== t22) {
    t23 = <Tooltip tooltip={t20} side="bottom">{t22}</Tooltip>;
    $[27] = t20;
    $[28] = t22;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <DotDivider />;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  const t25 = `First seen on ${issue.first_seen_at}`;
  let t26;
  if ($[31] !== issue.first_seen_at) {
    t26 = formatDistanceStrict(new Date(issue.first_seen_at), new Date());
    $[31] = issue.first_seen_at;
    $[32] = t26;
  } else {
    t26 = $[32];
  }
  let t27;
  if ($[33] !== t26) {
    t27 = <Text semi={true} muted={true} size="xs">{t26} old</Text>;
    $[33] = t26;
    $[34] = t27;
  } else {
    t27 = $[34];
  }
  let t28;
  if ($[35] !== t25 || $[36] !== t27) {
    t28 = <Tooltip tooltip={t25} side="bottom">{t27}</Tooltip>;
    $[35] = t25;
    $[36] = t27;
    $[37] = t28;
  } else {
    t28 = $[37];
  }
  let t29;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <DotDivider />;
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  let t30;
  let t31;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      align: "center",
      gap: 1
    };
    t31 = {
      px: 20
    };
    $[39] = t30;
    $[40] = t31;
  } else {
    t30 = $[39];
    t31 = $[40];
  }
  const t32 = issue_type_configs[issue.type];
  let t33;
  if ($[41] !== t32.icon) {
    t33 = <Icon icon={t32.icon} muted={true} />;
    $[41] = t32.icon;
    $[42] = t33;
  } else {
    t33 = $[42];
  }
  let t34;
  let t35;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      direction: "row",
      align: "center",
      gap: 1
    };
    t35 = {
      px: 20
    };
    $[43] = t34;
    $[44] = t35;
  } else {
    t34 = $[43];
    t35 = $[44];
  }
  const t36 = `/issue-triggers/${issue.issue_trigger_id}/issues`;
  let t37;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = {
      align: "center"
    };
    $[45] = t37;
  } else {
    t37 = $[45];
  }
  const t38 = issue_type_configs[issue.type];
  let t39;
  if ($[46] !== t38.label) {
    t39 = <Text semi={true} muted={true} size="xs" flex={t37}>{t38.label} issue</Text>;
    $[46] = t38.label;
    $[47] = t39;
  } else {
    t39 = $[47];
  }
  let t40;
  if ($[48] !== t36 || $[49] !== t39) {
    t40 = <Link flex={t34} h={t35} neutral={true} to={t36}>{t39}</Link>;
    $[48] = t36;
    $[49] = t39;
    $[50] = t40;
  } else {
    t40 = $[50];
  }
  let t41;
  if ($[51] !== t33 || $[52] !== t40) {
    t41 = <Div flex={t30} h={t31}>{t33}{t40}</Div>;
    $[51] = t33;
    $[52] = t40;
    $[53] = t41;
  } else {
    t41 = $[53];
  }
  let t42;
  if ($[54] !== t18 || $[55] !== t23 || $[56] !== t28 || $[57] !== t41) {
    t42 = <ClickableRow.Content flex={t7}><Div flex={t8}>{t18}{t19}{t23}{t24}{t28}{t29}{t41}</Div></ClickableRow.Content>;
    $[54] = t18;
    $[55] = t23;
    $[56] = t28;
    $[57] = t41;
    $[58] = t42;
  } else {
    t42 = $[58];
  }
  let t43;
  if ($[59] !== t42 || $[60] !== t6) {
    t43 = <Div flex={t5}>{t6}{t42}</Div>;
    $[59] = t42;
    $[60] = t6;
    $[61] = t43;
  } else {
    t43 = $[61];
  }
  let t44;
  let t45;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = {
      gap: 8
    };
    t45 = {
      l: 4
    };
    $[62] = t44;
    $[63] = t45;
  } else {
    t44 = $[62];
    t45 = $[63];
  }
  let t46;
  if ($[64] !== issue.id || $[65] !== issue.type || $[66] !== render_data) {
    t46 = issue.type !== "backpressure" && issue.type !== "request" && <Div w={{
      px: 140
    }} flex={{
      align: "center"
    }}><PreviewHistogram size="small" values={render_data.timeseries_by_issue_id && render_data.timeseries_by_issue_id[issue.id]?.map(_temp) || []} resolution="day" dimensions_config={{
        count: {
          color: "danger",
          label: "Count"
        }
      }} show_tooltip={true} /></Div>;
    $[64] = issue.id;
    $[65] = issue.type;
    $[66] = render_data;
    $[67] = t46;
  } else {
    t46 = $[67];
  }
  let t47;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = Object.keys(issue_actions);
    $[68] = t47;
  } else {
    t47 = $[68];
  }
  let t48;
  if ($[69] !== current_action || $[70] !== default_action || $[71] !== issue.dismissed_at || $[72] !== issue.status) {
    t48 = t47.filter(key => {
      if (key === current_action || key === default_action) {
        return false;
      }
      if (key === "dismiss" && issue.dismissed_at) {
        return null;
      }
      return issue.status === "OPENED" ? key !== "reopen" : true;
    });
    $[69] = current_action;
    $[70] = default_action;
    $[71] = issue.dismissed_at;
    $[72] = issue.status;
    $[73] = t48;
  } else {
    t48 = $[73];
  }
  let t49;
  if ($[74] !== applyAction || $[75] !== issue.id || $[76] !== t48) {
    t49 = t48.map(key_0 => ({
      label: issue_actions[key_0].label,
      role: issue_actions[key_0].role,
      icon: issue_actions[key_0].icon,
      onClick: () => applyAction([issue.id], key_0),
      danger: issue_actions[key_0].danger
    }));
    $[74] = applyAction;
    $[75] = issue.id;
    $[76] = t48;
    $[77] = t49;
  } else {
    t49 = $[77];
  }
  const t50 = issue_actions[default_action];
  let t51;
  if ($[78] !== applyAction || $[79] !== default_action || $[80] !== issue.id) {
    t51 = () => applyAction([issue.id], default_action);
    $[78] = applyAction;
    $[79] = default_action;
    $[80] = issue.id;
    $[81] = t51;
  } else {
    t51 = $[81];
  }
  const t52 = issue_actions[default_action];
  let t53;
  if ($[82] !== t52.icon) {
    t53 = <Icon icon={t52.icon} muted={true} left={true} />;
    $[82] = t52.icon;
    $[83] = t53;
  } else {
    t53 = $[83];
  }
  const t54 = issue_actions[default_action];
  let t55;
  if ($[84] !== t50.role || $[85] !== t51 || $[86] !== t53 || $[87] !== t54.label) {
    t55 = <Button.Permission role={t50.role} outline={true} onClick={t51}>{t53}{t54.label}</Button.Permission>;
    $[84] = t50.role;
    $[85] = t51;
    $[86] = t53;
    $[87] = t54.label;
    $[88] = t55;
  } else {
    t55 = $[88];
  }
  let t56;
  if ($[89] !== t49 || $[90] !== t55) {
    t56 = <ButtonGroup more_options={t49}>{t55}</ButtonGroup>;
    $[89] = t49;
    $[90] = t55;
    $[91] = t56;
  } else {
    t56 = $[91];
  }
  let t57;
  if ($[92] !== t46 || $[93] !== t56) {
    t57 = <ClickableRow.Content flex={t44} m={t45}>{t46}{t56}</ClickableRow.Content>;
    $[92] = t46;
    $[93] = t56;
    $[94] = t57;
  } else {
    t57 = $[94];
  }
  let t58;
  if ($[95] !== t2 || $[96] !== t43 || $[97] !== t57) {
    t58 = <ClickableRow to={t2} flex={t3} p={t4}>{t43}{t57}</ClickableRow>;
    $[95] = t2;
    $[96] = t43;
    $[97] = t57;
    $[98] = t58;
  } else {
    t58 = $[98];
  }
  return t58;
};
export default IssueSection;
function _temp(t0) {
  const [date, count] = t0;
  return {
    range: [date, date] as [Date, Date],
    values: {
      count
    }
  };
}